import { render, staticRenderFns } from "./Empacotados.vue?vue&type=template&id=80a8dc10&"
import script from "./Empacotados.vue?vue&type=script&lang=js&"
export * from "./Empacotados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports